<template>
  <div>
    <v-banner
      color="#00021a"
      class="text-center"
    >
    <v-icon class="pb-1" left>mdi-bullhorn</v-icon>
      This is a demo website that is fully functional. Test all features if interested.
    </v-banner>
    <v-container>
      <v-row class="mt-2">
        <v-spacer></v-spacer>
        <v-col class="mt-3">
          <span class="text-h6">Get started in 3 simple steps</span>
          <div>
            <v-card
              class="rounded-xl px-5 py-2 ma-4 "
              width="250"
              height="215"
              color="cardIsland"
              style="display:inline-block; vertical-align:top"
            >
              <v-card-title class="text-h6 font-weight-bold">
                <v-icon style="color:#00FF94">mdi-check-bold</v-icon>&nbsp; Step 1
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                Verify your email.
                <v-btn
                  class="my-4"
                  color="primary"
                  disabled
                >Verify Email</v-btn>
              </v-card-text>
            </v-card>
            <v-card
              color="cardIsland"
              class="rounded-xl px-5 py-2 ma-4"
              width="250"
              height="215"
              style="display:inline-block; vertical-align:top"
            >
              <v-card-title class="text-h6 font-weight-bold">
                <v-icon style="color:#00FF94">mdi-check-bold</v-icon>&nbsp; Step 2
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                Verify your identity.
                <v-btn
                  class="my-4"
                  color="primary"
                  disabled
                >Verify ID</v-btn> <br/>
              </v-card-text>
            </v-card>
            <v-card
              color="cardIsland"
              class="rounded-xl px-5 py-2 ma-4"
              width="250"
              height="215"
              style="display:inline-block; vertical-align:top"
            >
              <v-card-title class="text-h6 font-weight-bold">
                <v-icon style="color:#01B0FB">mdi-arrow-right-bold</v-icon>&nbsp; Step 3
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                Create an order! <br />
                <div class="d-flex flex-row my-2">
                  <v-btn
                    outlined
                    class="mr-2"
                    @click="showOrderForm('buy')"
                  >buy</v-btn>
                  <v-btn
                    color="primary"
                    @click="showOrderForm('sell')"
                  >sell</v-btn>
                </div>
                <span class="text-caption">Need a wallet? <router-link to="">Set up here.</router-link></span>
              </v-card-text>
            </v-card>
          </div>
          <div class="d-flex flex-row justify-space-between mt-5">
            <div class="text-h6">Order history</div>
            <v-btn
              outlined
              small
              class="mt-1"
              @click="exportOrderHistory"
              :disabled="isExportAllButtonDisabled"
            >Export All</v-btn>
          </div>
          <v-row>
            <v-col style="width:80vw">
              <v-simple-table
                class="mt-5"
                style="overflow-x:auto"
              >
                <template v-slot:default>
                  <tbody style="background-color:#1A1B23">
                    <tr style="background-color:#2C2D3A">
                      <th>Date</th>
                      <th>Type</th>
                      <th>Coin</th>
                      <th>Amount (AUD)</th>
                      <th>Status</th>
                      <th>Details</th>
                    </tr>
                    <template v-if="orders">
                      <tr
                        v-for="(order, id) in orderHistoryPages[page-1]"
                        :key="id"
                      >
                        <td>{{ formatDate(new Date(JSON.parse(order.createdAt)),'dd MMMM yyyy') }}</td>
                        <td>{{ capitaliseFirstLetter(order.orderType) }}</td>
                        <td :class="isMobile ? '': 'd-flex align-center'"><img src="../../assets/icons/btc.svg">
                          <div>&nbsp;&nbsp;Bitcoin</div>
                        </td>
                        <td>{{ formatCurrency(order.audAmount) }}</td>
                        <td>
                          <v-chip
                            v-if="order.status === 'unpaid' && order.validAtLastGet === false"
                            color="orange"
                            text-color="white"
                            small
                            outlined
                          >
                            Pending
                          </v-chip>
                          <v-chip
                            v-if="order.status === 'unpaid' && order.validAtLastGet === true"
                            color="orange"
                            text-color="white"
                            small
                            outlined
                            :style="showTimer ? 'width:60px': ''"
                          >
                            <CountdownTimer
                              v-if="showTimer"
                              class="text-caption"
                              :endDate="getExpirationTime(new Date(JSON.parse(order.confirmedAt)),5)"
                              typography="text-caption font-weight-medium"
                              @endTime="showTimer = false"
                            />
                            <span v-if="!showTimer">Pending</span>
                          </v-chip>
                          <v-chip
                            v-if="order.status === 'paid'"
                            color="green"
                            text-color="white"
                            small
                            outlined
                          >
                            Paid
                          </v-chip>
                          <v-chip
                            v-if="order.status === 'invalid'"
                            color="red"
                            text-color="white"
                            small
                            outlined
                          >
                            Invalid
                          </v-chip>
                        </td>
                        <td>
                          <router-link :to="`/order/${order.orderType}/${order.id}`">Details</router-link>
                        </td>
                      </tr>
                    </template>
                    <template v-if="orders && orders.length === 0">
                      <tr>
                        <td>
                          <span class="font-italic">No orders yet</span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <div class="mt-5">
            <v-pagination
              v-if="orders"
              v-model="page"
              :length="Math.ceil(orders.length/5)"
              circle
              color="primary"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>

</template>

<script>
import Order from './Order.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { utilsMixin } from '../../mixins/utilsMixin'
import CountdownTimer from "../../components/CountdownTimer.vue"


export default {
  components: {
    Order,
    CountdownTimer,
  },
  mixins: [utilsMixin],
  data() {
    return {
      page: 1,
      showTimer: true,
    }
  },
  computed: {
    ...mapState("auth", ["accessToken"]),
    ...mapState("order", ["orders"]),
    ...mapState("utils", ["isLoadingOverlay"]),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    isExportAllButtonDisabled() {
      return this.orders?.length === 0
    },
    orderHistoryPages() {
      return this.orders.reduce((acc, val, i) => {
        const index = Math.floor(i / 5)
        const page = acc[index] || (acc[index] = [])
        page.push(val)
        return acc
      }, [])
    },
    orderHistoryCsv() {
      const objArray = this.orders.map(item => { return { date: this.formatDate(new Date(JSON.parse(item.createdAt)), 'dd MMMM yyyy'), type: item.orderType, coin: 'Bitcoin', amount: item.audAmount, status: item.status, details: item.id } })
      const array = [Object.keys(objArray[0])].concat(objArray)
      return array.map(item => {
        return Object.values(item).toString()
      }).join('\n')
    }
  },
  methods: {
    ...mapMutations('order', ['setOrder']),
    ...mapMutations('utils', ['setIsLoadingOverlay']),
    ...mapActions("order", ["getOrders"]),
    ...mapActions("auth", ["getUser", "getAccessToken"]),
    showOrderForm(orderType) {
      this.$router.push({ path: `/order/${orderType}` })
    },
    getExpirationTime(startTime, minutesToAdd) {
      return new Date(startTime.getTime() + minutesToAdd * 60000);
    },
    exportOrderHistory() {
      this.downloadBlob(this.orderHistoryCsv, `EasyCryptoOrders_${this.formatDate(new Date(), 'ddMMyyyy')}.csv`, 'text/csv;charset=utf-8;')
    },
    downloadBlob(content, filename, contentType) {
      // Create a blob
      const blob = new Blob([content], { type: contentType });
      const url = URL.createObjectURL(blob);

      // Create a link to download it
      const pom = document.createElement('a');
      pom.href = url;
      pom.setAttribute('download', filename);
      pom.click();
    }
  },
  async mounted() {
    this.setIsLoadingOverlay(true)
    await this.getUser()
    this.setOrder(null)
    await this.getAccessToken()
    await this.getOrders()
    this.$nextTick(() => {
      this.setIsLoadingOverlay(false)
    })
  },
}
</script>
